module.exports = __webpack_public_path__ + "static/media/bg_2.85020146.jpg";